The schema's entry-point for queries.

This acts as the public, top-level API from which all queries must start.
